import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { BadgeScore } from 'src/app/shared/components/badgeScore';

type Props = { score: number };
export const PetitionStrengthCard: React.FC<Props> = ({ score }) => {
	return (
		<Flex
			p={24}
			sx={{
				backgroundColor: 'background',
				borderRadius: 'standard',
				flexDirection: 'column',
				gap: 16,
				height: '100%',
				minWidth: 200,
			}}
		>
			<Text as="p" size="small" fontWeight="bold" sx={{ whiteSpace: 'nowrap' }}>
				<Translate value="corgi.petition.details.strength_score.title" />
			</Text>
			<BadgeScore
				score={score}
				sx={{
					'& #score-text': { fontSize: '14px' },
				}}
			/>
		</Flex>
	);
};
